import { get, post } from 'axios'

const host = process.env.VUE_APP_CCAPI

function register (preRequestLoan) {
    const resource = `/fas/loan_request/register`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = preRequestLoan;

    return post(API_URL,  params, config )
}

function getCatalog (token_auth, saving) {
    const resource = `/fas/loan_catalog/get_list`
    const API_URL = `${host}${resource}`
    
    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        saving: saving
    }
    
    return get(API_URL, { params, config })
}
    
export {
    getCatalog,
    register
}